package com.eladfinish.bible.contest.screens.browse.usecases

import com.eladfinish.bible.contest.data.common.AssetReader
import com.eladfinish.bible.contest.data.common.DocumentTextType
import com.eladfinish.bible.contest.data.common.DocumentsExporter
import com.eladfinish.bible.contest.extensions.replaceRegex
import com.eladfinish.bible.contest.platform.share.ShareTextFormatter
import com.eladfinish.bible.contest.screens.browse.contentOfChapter.BrowseChaptersStore.Companion.CHAPTERS_FOLDER
import com.eladfinish.bible.contest.screens.chapterComplete.usecases.GetJsonEncodedBlanksUseCase

class SaveChapterFileUseCase(
    private val assetReader: AssetReader,
    private val getJsonEncodedBlanksUseCase: GetJsonEncodedBlanksUseCase,
    private val documentsExporter: DocumentsExporter,
    private val shareTextFormatter: ShareTextFormatter,
) {

    operator fun invoke(
        bookAndChapter: String,
        content: String,
        completeChapter: Boolean,
        currentBook: Int,
        currentPart: Int,
        documentTextType: DocumentTextType = DocumentTextType.TXT,
    ): Boolean {
        val name = bookAndChapter.replaceRegex(regex = "\"", replacement = "").trim()
        val jsonEncodedBlanks = if (completeChapter) {
            getJsonEncodedBlanksUseCase(
                indexPickedBook = currentBook,
                num = currentPart,
                selectedText = content
            )
        } else {
            ""
        }

        return documentsExporter.saveTextFileToDocuments(
            folder = CHAPTERS_FOLDER,
            name = name,
            content = buildString {
                append(content)
                append("\n\n")
                append(jsonEncodedBlanks)
                append("\n\n")
                append(
                    shareTextFormatter.format(
                        assetReader = assetReader,
                        documentTextType = documentTextType,
                    )
                )
            },
            type = documentTextType,
        )
    }
}
